import {type IAssetView} from './schema';

export const assetViewDefaults: IAssetView = {
	viewId: 0,
	imageId: 0,
	autoTaskId: 0,
	fileTypeId: 0,
	fileSize: 0,
	fileWidth: 0,
	fileHeight: 0,
	name: '',
	description: '',
	creationDate: '',
	thumb: '',
	fileTypeLabel: '',
	fileSizeLabel: '',
	viewMetadataLabels: [],
	viewMetadataValues: [],
};
